var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadBtnForCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9869_8397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 86,
    height: 86,
    rx: 43,
    fill: "url(#paint0_linear_9869_8397)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9869_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.535 42.1428V71.4423C73.535 74.377 71.1557 76.7562 68.2211 76.7562H41.7475C38.8128 76.7562 36.4336 74.377 36.4336 71.4423V34.558C36.4336 31.6234 38.8128 29.2441 41.7475 29.2441H61.2524V38.0485C61.2524 40.319 63.088 42.1546 65.3585 42.1546H73.535V42.1428Z",
    fill: "#B5FF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 29.2441L73.5326 42.155H65.3561C63.0856 42.155 61.25 40.319 61.25 38.0485V29.2441Z",
    fill: "#B5FF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1201 28.3864C61.8909 28.145 61.5769 28 61.2508 28H41.7458C38.1467 28 35.1758 30.9591 35.1758 34.5578V71.4422C35.1758 75.0409 38.1467 78 41.7458 78H68.2195C71.8182 78 74.7891 75.0409 74.7891 71.4422V42.1426C74.7891 41.8287 74.6442 41.5265 74.4389 41.2973L62.1201 28.3864ZM62.4707 32.2633L70.7192 40.9227H65.3569C63.7627 40.9227 62.4707 39.6425 62.4707 38.0361V32.2633ZM68.2195 75.5845H41.7458C39.4875 75.5845 37.5912 73.7127 37.5912 71.4422V34.5578C37.5912 32.2995 39.4753 30.4155 41.7458 30.4155H60.0552V38.0361C60.0552 40.9711 62.4223 43.3381 65.3569 43.3381H72.374V71.4422C72.374 73.7127 70.49 75.5845 68.2195 75.5845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9228 67.251H45.0437C44.3795 67.251 43.8359 67.7942 43.8359 68.4587C43.8359 69.1228 44.3795 69.6664 45.0437 69.6664H64.935C65.5992 69.6664 66.1428 69.1228 66.1428 68.4587C66.1428 67.7942 65.5992 67.251 64.9228 67.251Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1001 62.9158C54.3298 63.1573 54.6437 63.3023 54.9817 63.3023C55.3201 63.3023 55.634 63.1573 55.8633 62.9158L62.9285 55.3193C63.3878 54.8359 63.3515 54.0631 62.8682 53.6164C62.3853 53.1575 61.612 53.1937 61.1653 53.6767L56.1894 59.0271V45.8386C56.1894 45.1745 55.6462 44.6309 54.9817 44.6309C54.3176 44.6309 53.774 45.1741 53.774 45.8386V59.0268L48.7981 53.6767C48.3392 53.1937 47.5785 53.1575 47.0952 53.6164C46.6123 54.0753 46.576 54.8359 47.0349 55.3189L54.1001 62.9158Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9869_8397",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9869_8397"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9869_8397",
    result: "effect2_dropShadow_9869_8397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9869_8397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9869_8397",
    x1: 66.0522,
    y1: 195.438,
    x2: 28.5638,
    y2: -1.76492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9869_8397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(30 28)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtnForCarousel);
export default __webpack_public_path__ + "static/media/download-btn-for-carousel.fb46c4f591ffa4009e1cc52aeb7fea2f.svg";
export { ForwardRef as ReactComponent };